import { render, staticRenderFns } from "./myAnswer.vue?vue&type=template&id=3ac2a892&scoped=true&"
import script from "./myAnswer.vue?vue&type=script&lang=js&"
export * from "./myAnswer.vue?vue&type=script&lang=js&"
import style0 from "./myAnswer.vue?vue&type=style&index=0&id=3ac2a892&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac2a892",
  null
  
)

export default component.exports